import { Chip, FormHelperText, MenuItem, Select, Tooltip } from "@mui/material";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import useStyles from "../../style/js-style/components/rules/EARuleAccordionStyle";
import { find, get as lodashGet } from "lodash";
import { DefaultSelectProps } from "../../services/common/Constants";
import i18next from "i18next";

const EAMultipleSelectChips = ({
  fieldName,
  options,
  selected,
  placeholder,
}) => {
  const { classes } = useStyles();
  const formMethods = useFormContext();

  if (!selected || selected.length === 0) {
    return <span className={classes.placeHolder}>{placeholder}</span>;
  }

  const getChipClass = (index) => {
    return selected.length === index + 1 && selected.length % 2 !== 0
      ? classes.largeChip
      : classes.chip;
  };

  const getEntryLabel = (value) => {
    let entry = find(options, { value: value });

    return entry === undefined ? "" : entry.label;
  };

  return (
    <>
      <div className={classes.chipsContainer}>
        {selected.map((value, index) => {
          return (
            <Tooltip key={index} title={getEntryLabel(value)}>
              <Chip
                className={getChipClass(index)}
                key={value}
                label={getEntryLabel(value)}
                deleteIcon={
                  <img
                    src={process.env.PUBLIC_URL + "/img/icons/cross.svg"}
                    alt="close"
                    onMouseDown={(event) => event.stopPropagation()}
                    className={classes.deleteItemIcon}
                  />
                }
                sx={{
                  borderRadius: 0,
                  backgroundColor: "#F2F3F7",
                  color: "#535362",
                  padding: 0,
                  fontSize: "12px",
                  fontWeight: 500,
                  height: "auto",
                  border: 0,
                  maxWidth: "125px",
                  "& .MuiChip-label": {
                    paddingLeft: "4px",
                    paddingRight: "12px",
                  },
                }}
                onDelete={(event) => {
                  event.preventDefault();
                  formMethods.setValue(
                    fieldName,
                    selected?.filter((x) => x !== value)
                  );
                }}
              />
            </Tooltip>
          );
        })}
      </div>
    </>
  );
};

const EAMultipleSelectInput = ({
  fieldName,
  options,
  defaultValue,
  onChange,
  placeholder,
  isRequired,
  variant = "default",
  disabled = false,
  values = null
}) => {
  const formMethods = useFormContext();
  const { classes } = useStyles();
  return (
    <div style={{paddingLeft: variant === "fullSize" ? "16px" : "auto"}}>
      <Controller
        control={formMethods.control}
        name={fieldName}
        defaultValue={defaultValue}
        rules={{
          validate: (value) => {
            if (isRequired) {
              const isEmpty = value.length === 0;
              if (isEmpty) {
                return i18next.t("infos.required");
              } else {
                formMethods.clearErrors(fieldName);
              }
            }
          },
        }}
        render={({ field }) => (
          <Select
            {...field}
            value={values || formMethods.getValues(fieldName)}
            id="ea-multiselect-id"
            multiple
            displayEmpty
            onChange={(event) => {
              formMethods.setValue(fieldName, event.target.value);
              formMethods.trigger(fieldName);
              onChange(event);
            }}
            variant="standard"
            MenuProps={DefaultSelectProps.MenuProps}
            className={classes.select}
            style={{
              width: variant === "fullSize" ? "calc(100vw - 775px)" : "100%",
            }}
            error={!!lodashGet(formMethods.formState.errors, `${fieldName}`)}
            disabled={disabled}
            renderValue={(selected) => (
              <EAMultipleSelectChips
                fieldName={fieldName}
                selected={selected}
                options={options}
                formMethods={formMethods}
                placeholder={placeholder}
              />
            )}
          >
            {options?.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        )}
      />

      {!!lodashGet(formMethods.formState.errors, `${fieldName}`) && (
        <FormHelperText className="Mui-error">
          {lodashGet(formMethods.formState.errors, `${fieldName}.message`)}
        </FormHelperText>
      )}
    </div>
  );
};

export default EAMultipleSelectInput;
